module.exports = __webpack_public_path__ + "img/icon-success.c8bb7cab.png";